module.exports = __webpack_public_path__ + "img/tg_swper02.1c8d3f3a.png";